import React from "react";
import Hero from "../components/Hero";
import FeatureStrip from "../components/FeatureStrip";
import Categories from "../components/Categories";
import Services from "../components/Services";
import { Catalogs, News } from "../components/Sections";
import CTAStrip from "../components/CTAStrip";

const Home = () => {
  return (
    <>
      <Hero />
      <FeatureStrip />
      <Categories />
      <Services />
      <Catalogs />
      <News />
      <CTAStrip />
    </>
  );
};

export default Home;
